export function useQueryItemBase(name, query, { onChange = () => {}, transform = (val) => val } = {}) {
    function set(newVal) {
        query.value = transform(newVal)
        onChange()
    }

    function setNull() {
        query.value = 'is_null'
        onChange()
    }

    function setUnreviewed() {
        query.value = 'is_unreviewed'
        onChange()
    }

    function reset() {
        query.value = null
        onChange()
    }

    function toValue() {
        return query.value
    }

    function toPayload() {
        const payload = {}
        payload[name] = query.value
        return payload
    }

    return {
        set,
        toPayload,
        toValue,
        setNull,
        setUnreviewed,
        reset,
    }
}
